"use client";
import "../../chunk-MMUBH76A.js";
import { getNetworkName } from "../constants/constants.js";
import { format } from "date-fns";
const formatNetworkList = (networks) => {
  return networks.length === 1 ? getNetworkName(networks[0]) : `${networks.map((id) => getNetworkName(id)).slice(0, -1).join(", ")}${networks.length > 2 ? "," : ""} and ${getNetworkName(networks[networks.length - 1])}`;
};
const formatWalletCreatedDate = (date) => `${format(new Date(date), "M/d/y")}`;
const camelToSnakeCase = (str) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
const formatBalanceString = (str) => {
  const numericBalance = parseFloat(str);
  return `$${numericBalance.toLocaleString(void 0, { maximumFractionDigits: 2 })}`;
};
export {
  camelToSnakeCase,
  formatBalanceString,
  formatNetworkList,
  formatWalletCreatedDate
};
